import axios from "axios";
import { BASE_URL } from "../helper";

export const fetchPublicToken = async () => {
  let response = null;
  try {
    response = await axios.get(`${BASE_URL}/public/token/`, {
      headers: {
        "Cache-Control": "no-store,no-cache",
      },
    });
  } catch (err) {
    if (err instanceof Error) {
      console.error("Error occurred while fetching token!");
    }
  }
  return response?.data.token;
};
